import API from "../Common/Endpoint/serviceConstrants";
import axiosInstance from "../Common/Axios/axiosInstance";

// This is now a GiftStacc gateway call, so it uses the standard API JWT,
// encryption and credentialed-cookie Axios instance. axiosIntegration is only
// for direct AI Loyalty integration routes and must not own the SSO exchange.
export const validateLoginTokenApi = async (payload) => {
  const { data = {} } = await axiosInstance.post(
    API.validate_login_token_v2,
    {
      loginSessionToken: payload?.loginSessionToken,
      temporaryToken: payload?.temporaryToken,
      urlReferrer: payload?.urlReferrer,
    },
    { withCredentials: true }
  );
  return data;
};
